import { Flex, Stack } from '@grubhubprod/gh-cookbook-react/dist';
import React from 'react';

import { Button, SvgDownload } from '@grubhubprod/gh-cookbook-react';
import { useDownloadPdfFile } from 'src/components/selfService/features/OrderHistory/hooks/useDownloadPdfFile';

export interface DownloadStateButtonProps {
  downloadUrl: string;
  filename: string;
  onError: () => void;
}

export function DownloadStateButton({
  downloadUrl,
  filename,
  onError,
}: DownloadStateButtonProps): JSX.Element {
  const { getPDFFileFromS3 } = useDownloadPdfFile({
    downloadUrl,
    filename,
    onError,
  });
  return (
    <Button
      variant="tertiary"
      buttonSize="medium"
      className="tableActionButtons"
      onClick={getPDFFileFromS3}
    >
      <Flex alignItems="center" className="ellipsisOverflow">
        <Stack x="xx-sm">Download pdf</Stack>
        <SvgDownload size="20px" />
      </Flex>
    </Button>
  );
}
